<template>
  <b-overlay :show="isShow" class="loader" fixed no-wrap no-center>
    <template #overlay>
      <div class="loader">
        <div class="wrap-custom-progress">
          <h1 class="mb-3">Downloading Labels</h1>
          <b-progress height="45px" :max="max">
            <span class="progress-value">{{ progress }} %</span>
            <b-progress-bar :value="progress" />
          </b-progress>
          <p class="mt-1 text-xxs" v-text="message ? message : 'Waiting for the server to start processing.'" />
          <p class="text-center mt-4">This can take up to several minutes, depending on how busy the server is.</p>
        </div>
      </div>
    </template>
  </b-overlay>
</template>

<script lang="ts">
import { notify } from '@kyvg/vue3-notification'
import { ref, computed, watch, defineComponent } from 'vue'
import { LABELS_DOWNLOAD_LOADER } from '@/const/LoadersNames'
import { checkMessage, parseLoaderProgress } from '@/services/WebSockets'
import { useAccountStore } from '@/store/account'
import { useUiStore } from '@/store/ui'

export default defineComponent({
  name: 'DownloadLabelsLoader',
  props: {
    show: {
      type: Boolean,
      default: true,
    },
  },
  setup() {
    const accountStore = useAccountStore()
    const uiStore = useUiStore()
    const max = ref(100)
    const progress = ref(0)
    const message = ref<string | null>(null)

    const loader = computed(() => uiStore.loader ?? null)
    const userId = computed(() => accountStore.userId)
    const isShow = computed(() => loader.value?.name === LABELS_DOWNLOAD_LOADER && Boolean(loader.value?.show))

    watch(isShow, (val) => {
      const channel = `App.User.${userId.value}`
      if (val) {
        message.value = null
        checkMessage(message, progress)
        window.Echo.private(channel)
          .listen('Assignment\\AssignmentLabelsCreated', (result: any) => {
            progress.value = 100
            setTimeout(() => {
              uiStore.loaderHide()
              window.open(result.labelsDownloadUrl, '_blank')
              if (typeof loader.value?.data?.callback !== 'undefined') {
                loader.value.data.callback()
              }
            }, 1000)
          })
          .listen('Assignment\\AssignmentLabelsFailed', (result: any) => {
            progress.value = 100
            setTimeout(() => {
              uiStore.loaderHide()
              notify({ group: 'error', text: 'Error archiving labels. ' + (result.message ? result.message : '') })
            }, 1000)
          })
          .listen('.loader-progress', (response: any) => parseLoaderProgress(response, message, progress))
        progress.value = 0
      } else {
        window.Echo.leave(channel)
        progress.value = 0
      }
    })

    return {
      max,
      progress,
      message,
      isShow,
    }
  },
})
</script>
